module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Mobile-Devices-1.b24b0b5c.jpg";